var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsertChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 18.6875V13.3125H16V18.6875H18.6875ZM13.3125 18.6875V5.3125H10.6875V18.6875H13.3125ZM8 18.6875V9.3125H5.3125V18.6875H8ZM21.3125 0C22.0208 0 22.6458 0.270833 23.1875 0.8125C23.7292 1.35417 24 1.97917 24 2.6875V21.3125C24 22.0208 23.7292 22.6458 23.1875 23.1875C22.6458 23.7292 22.0208 24 21.3125 24H2.6875C1.97917 24 1.35417 23.7292 0.8125 23.1875C0.270833 22.6458 0 22.0208 0 21.3125V2.6875C0 1.97917 0.270833 1.35417 0.8125 0.8125C1.35417 0.270833 1.97917 0 2.6875 0H21.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertChart);
export default __webpack_public_path__ + "static/media/insert_chart.e104a753edb3b35fef483266d462013f.svg";
export { ForwardRef as ReactComponent };